import React from 'react';

import { Button, Checkbox, Input, Select } from 'antd';
import { ValueSelectorProps, ValueEditorProps, ActionProps, FieldSelectorProps } from 'react-querybuilder';
import DatePickerWithFormat from 'src/pages/observers/components/DatePickerWithFormat';

export const CustomValueEditor = (
	{
		inputType,
		value,
		handleOnChange,
	}: ValueEditorProps) => {

	switch(inputType){
		case 'date':
			return <DatePickerWithFormat
				size='small'
				onDateChange={(value) =>
					handleOnChange(value)
				}
			/>;
		case 'boolean':
			return <Checkbox
				style={{ width: '100%', }}
				checked={value}
				onChange={(e) => handleOnChange(e.target.checked)}
			/>;
		case 'number':
			return <Input
				size='small'
				value={value}
				onChange={(e) => {
					const value = e.target.value;
					const formattedValue = value.replace(/[^0-9., ]/g, '');
					handleOnChange(formattedValue);
				}}
			/>;
		default:
			return <Input
				size='small'
				value={value}
				onChange={(e) => {
					const value = e.target.value;
					handleOnChange(value);
				}}
			/>;
	}
};

export const CustomValueSelector = (
	{
		handleOnChange,
		options,
		title,
		disabled,
		value,
	}: ValueSelectorProps) => (
	<Select
		style={{ minWidth: '100px', }}
		onChange={handleOnChange}
		size='small'
		//@ts-ignore
		options={options}
		title={title}
		disabled={disabled}
		value={value}
	/>
);

export const CustomFieldSelector = (
	{
		handleOnChange,
		options,
		title,
		disabled,
		value,
	}: FieldSelectorProps) => (
	<Select
		style={{ maxWidth: 165, }}
		onChange={handleOnChange}
		size='small'
		//@ts-ignore
		options={options}
		title={title}
		disabled={disabled}
		value={value}
	/>
);

export const CustomActionElement = (
	{
		label,
		handleOnClick,
		disabled,
		title,
	}: ActionProps) => (
	<Button
		onClick={handleOnClick}
		size='small'
		title={title}
		disabled={disabled}
	>
		{label}
	</Button>
);